import { apiConfig } from '../api-config';

export interface ActPdfParams {
  tokenKey: string;
  carNumber: string;
  cdAgent: string;
  validityDateACT: string;
  issueDateACT: string;
  territoryName: string;
  city: string;
  state: string;
}

export const actPdfCreate = async (params: ActPdfParams) => apiConfig
  .post('api/DocumentAct/create-pdf', params)
  .then((resp) => resp.data)
  .catch((err) => err);
